import { Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';

export default function NotFound() {
  return (
    <Layout>
      <div className="pt-24 pb-16 min-h-screen flex items-center justify-center">
        <div className="text-center px-4">
          <div className="w-28 h-28 mx-auto flex items-center justify-center rounded-full bg-background-100 text-foreground-300 mb-6">
            <i className="ri-emotion-sad-line text-5xl"></i>
          </div>
          <h1 className="text-2xl font-heading font-bold text-foreground-800 mb-2">
            404 - 页面不存在
          </h1>
          <p className="text-foreground-500 mb-8 max-w-md mx-auto">
            您访问的页面可能已被删除、更名或暂时不可用。请检查网址是否正确，或返回首页继续浏览。
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-home-line"></i>
            返回首页
          </Link>
        </div>
      </div>
    </Layout>
  );
}